import React, { useEffect } from "react";
import backgroundPP from "../assets/recurso_42.png";
import backgroundCC from "../assets/Recurso_50.png";
import backgroundDD from "../assets/Recurso_51.png";
import backgroundSU from "../assets/Recurso_52.png";
import iso from "../assets/iso.png";
import accion_clima from "../assets/accion_clima.png";

function SectorTemplate({
  tituloPildora,
  background,
  mainTitle,
  description,
  bullets,
  showEnsayosHeading = false,
  rightLogo,
  rightLogoWidth,
  mobileBackgroundPosition,
  desktopBackgroundPosition = "center center",
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const resolvedMobileBackgroundPosition =
    mobileBackgroundPosition ||
    {
      "STOCK DE MATERIAS PRIMAS": "36% center",
      LABORATORIO: "58% center",
      "DESARROLLO DE PRODUCTOS": "52% center",
    }[mainTitle] ||
    "50% center";

  return (
    <section
      className="sector-hero relative bg-cover bg-no-repeat animate-fade-up"
      style={{
        backgroundImage: `url(${background})`,
        "--sector-bg-mobile": resolvedMobileBackgroundPosition,
        "--sector-bg-desktop": desktopBackgroundPosition,
      }}
    >
      <div className="sector-hero-overlay grid grid-cols-1 bg-black bg-opacity-50">
        <div className="sector-content min-w-0 flex flex-col">
          <div className="flex flex-row justify-between items-center gap-3 border-r border-b border-white p-4 sm:p-6">
            <h1
              className="max-w-[70%] text-white text-xs sm:text-lg leading-tight font-gotham font-light border border-white px-3 sm:pr-8 py-1 rounded-full uppercase"
              data-scroll-reveal
            >
              {tituloPildora}
            </h1>
            <div
              className={rightLogoWidth ? `${rightLogoWidth} max-w-12 sm:max-w-none shrink-0` : "w-24 sm:w-40 shrink-0"}
              data-scroll-reveal
              data-scroll-reveal-delay="80ms"
            >
              <img src={rightLogo || iso} alt="right-logo" className="w-full" />
            </div>
          </div>
          <div className="flex flex-1 flex-col pt-10 sm:pt-16 px-5 sm:px-12 lg:px-20 pb-8 border-r border-b border-white mb-8 sm:mb-20 rounded-br-2xl sm:rounded-br-3xl">
            <h2
              className="max-w-full text-white text-4xl sm:text-6xl leading-[0.98] font-gotham font-medium uppercase break-words"
              data-scroll-reveal
              data-scroll-reveal-delay="90ms"
            >
              {mainTitle}
            </h2>
            {description && (
              <p
                className="text-white text-[15px] sm:text-xl font-gotham font-light mt-4 max-w-4xl leading-relaxed"
                data-scroll-reveal
                data-scroll-reveal-delay="160ms"
              >
                {description}
              </p>
            )}
            {showEnsayosHeading && (
              <h4 className="text-white text-lg sm:text-xl font-gotham font-medium mt-6" data-scroll-reveal data-scroll-reveal-delay="210ms">ENSAYOS</h4>
            )}
            {Array.isArray(bullets) && bullets.length > 0 && (
              <ul className="mt-2" data-scroll-reveal data-scroll-reveal-delay="240ms">
                {bullets.map((b, idx) => (
                  <li key={idx} className="text-white text-sm sm:text-lg font-gotham font-light mt-1">{b}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export function ProcesoProductivoPage() {
  return (
    <SectorTemplate
      tituloPildora="Proceso Productivo"
      background={backgroundPP}
      mainTitle="STOCK DE MATERIAS PRIMAS"
      description="Contamos con stock de materia prima en diferentes tipos y gramajes."
      bullets={["• PAPEL BLANCO", "• PAPEL KRAFT", "• IMPORTADO", "• PAPEL NACIONAL", "• RECICLADO"]}
    />
  );
}

export function ControlDeCalidadPage() {
  return (
    <SectorTemplate
      tituloPildora="Control de Calidad"
      background={backgroundCC}
      mainTitle="LABORATORIO"
      description={
        "La materia prima recibida en planta es intervenida por nuestro laboratorio de control de calidad, realizando los ensayos que establecen las normas del rubro. Además se realizan ensayos periódicos en INTI Celulosa y Papel para para un mayor control."
      }
      showEnsayosHeading={true}
      bullets={[
        "COBB: TAPPI 441",
        "GRAMAJE: TAPPI 410",
        "RCT: TAPPI 818",
        "SCT: TAPPI 826",
        "POROSIDAD: TAPPI 460",
        "ESTALLIDO: TAPPI 403",
      ]}
    />
  );
}

export function DisenoYDesarrolloPage() {
  return (
    <SectorTemplate
      tituloPildora="DISEÑO Y DESARROLLO"
      background={backgroundDD}
      mainTitle="DESARROLLO DE PRODUCTOS"
      description={
        "Previamente a la fabricación de cualquier producto, se analiza dentro del área de diseño y desarrollo las necesidades puntuales de cada cliente. Una vez definidas las mismas, comienza nuestro proceso productivo."
      }
      bullets={[
        "DETERMINACION DE MEDIDAS",
        "Y E.C. ENSAYO BCT. CALCULO DE ESTIBA Y PALLETIZADO ARMADO DE ORIGINALES",
      ]}
    />
  );
}

export function SustentabilidadPage() {
  return (
    <SectorTemplate
      tituloPildora="Sustentabilidad"
      background={backgroundSU}
      mainTitle="PLAN DE ECONOMÍA CIRCULAR"
      description={
        "El objetivo del plan consiste en recolectar el scrap productivo de Entrecor y el desperdicio industrial de cajas cartón corrugado de empresas consumidoras de este tipo de envases. Es primordial devolver a la industria la mayor cantidad posible de materia prima para la fabricación del papel para corrugar."
      }
      bullets={["EL SCRAP PRODUCTIVO ES ENFARDADO EN PLANTA."]}
      rightLogo={accion_clima}
      rightLogoWidth="w-16"
    />
  );
}
